// extracted by mini-css-extract-plugin
export default {"resumoTurma":"ranking_resumoTurma__c-ccY"};